import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery';
export const ASSET_CLASS_REPORT = 'assetClassReportApi';

export const assetClassReportApi = createApi({
    reducerPath: ASSET_CLASS_REPORT,
    baseQuery: apiBaseQuery,
    tagTypes: ['assetClass'],
    endpoints: (builder) => ({
        getAssetClassReport: builder.query({
            query: ({ along_with, year, metric }) => ({
                url: `/portfolio/reports/by-${metric}?year=${year}&limit=100&along_with=${along_with}`
            }),
            providesTags: ['assetClass']
        }),
        sectorWiseClimateRisk: builder.query({
            query: ({ climate_scenario, year, limit }) => ({
                url: `/portfolio/reports/by-sector-climate-risk?year=${year}&climate_scenario=${climate_scenario}&limit=${limit}`
            }),
            providesTags: ['assetClass']
        }),
        climateRiskStats: builder.query({
            query: ({ climate_scenario, year }) => ({
                url: `/portfolio/reports/climate-risk-exposure?year=${year}&climate_scenario=${climate_scenario}`
            }),
            providesTags: ['assetClass']
        }),
        climateScenarios: builder.query({
            query: () => ({
                url: `/admin/repository/climate-scenarios`
            }),
            providesTags: ['assetClass']
        }),
        createReport: builder.mutation({
            query: (body) => ({
                url: `/portfolio/reports`,
                method: 'POST',
                body
            }),
            invalidatesTags: ['assetClass']
        }),
        resetPortfolio: builder.mutation({
            query: () => ({
                url: `/portfolio/reset`,
                method: 'DELETE',
            }),
            invalidatesTags: ['assetClass']
        }),
        getReports: builder.query({
            query: ({ page, limit }) => ({
                url: `/portfolio/reports?page=${page}&limit=${limit}`
            }),
            providesTags: ['assetClass']
        }),
        getThreeYearReports: builder.query({
            query: ({ page, limit, year }) => ({
                url: `/portfolio/reports/by-3year-emission?year=${year}&page=${page}&limit=${limit}`
            }),
            providesTags: ['assetClass']
        }),

    })
});

export const {
    useGetAssetClassReportQuery,
    useSectorWiseClimateRiskQuery,
    useClimateRiskStatsQuery,
    useClimateScenariosQuery,
    useCreateReportMutation,
    useGetReportsQuery,
    useGetThreeYearReportsQuery,
    useResetPortfolioMutation,
} = assetClassReportApi;